import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import 'leaflet/dist/leaflet.css';
import { installChunkReloadHandlers } from './utils/chunkReload';
import { NewVersionWatcher } from './components/NewVersionWatcher';

// Auto-reload once if a lazy-loaded chunk 404s after a mid-session deploy.
installChunkReloadHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* An open tab picks up a new deploy by itself (2026-10-23). */}
      <NewVersionWatcher />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
